import { useNotificationStore } from '@/modules/common/store/notifications'

export function useNotification() {
  const notificationStore = useNotificationStore()

  const showSuccess = (message: string) => {
    notificationStore.showSuccess(message)
  }

  const showError = (message: string) => {
    notificationStore.showError(message)
  }

  const showWarning = (message: string) => {
    notificationStore.showWarning(message)
  }

  const showInfo = (message: string) => {
    notificationStore.showInfo(message)
  }

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  }
}
